/**
 * @deprecated Use consts.js instead where values are hardcoded in js.
 */
export default {
    get: function (key) {
        if (!window.panelConstants) {
            throw Error("No global constants object available.");
        }

        const value = window.panelConstants[key];

        if (!value && value !== 0) {
            throw Error("Constant '" + key + "' is not available");
        }

        return value;
    },
};
